module.exports = __webpack_public_path__ + "static/media/BE1ConsultingUG.a8facdaa.jpg";